import React from "react";
import { Box, Tab, Tabs } from "@mui/material";
import { Article as ArticleIcon, Comment as CommentIcon, History as HistoryIcon } from "@mui/icons-material";
import { getTranslation } from "common";

export type MobileDetailTabValue = "data" | "comments" | "history";

interface MobileDetailTabBarProps {
  value: MobileDetailTabValue;
  onChange: (next: MobileDetailTabValue) => void;
  commentsCount: number;
  historyCount: number;
  translations: Record<string, string>;
}

/**
 * Tab bar inside the mobile task detail (Scheda & Campi | Commenti | Storia).
 * Mirrors the desktop ToggleButtonGroup (commenti/storia) plus the data tab.
 */
const MobileDetailTabBar: React.FC<MobileDetailTabBarProps> = ({
  value,
  onChange,
  commentsCount,
  historyCount,
  translations,
}) => {
  return (
    <Box sx={{ borderBottom: "1px solid", borderColor: "divider", bgcolor: "background.paper" }}>
      <Tabs
        value={value}
        onChange={(_, next: MobileDetailTabValue) => onChange(next)}
        variant="fullWidth"
        TabIndicatorProps={{ sx: { height: 2, bgcolor: "primary.main" } }}
        sx={{
          minHeight: 40,
          "& .MuiTab-root": {
            minHeight: 40,
            py: 0.75,
            fontSize: 11,
            fontWeight: 700,
            textTransform: "none",
          },
        }}
      >
        <Tab
          value="data"
          icon={<ArticleIcon sx={{ fontSize: 14 }} />}
          iconPosition="start"
          label={getTranslation(translations, "process_model.schema.title")}
        />
        <Tab
          value="comments"
          icon={<CommentIcon sx={{ fontSize: 14 }} />}
          iconPosition="start"
          label={
            <Box sx={{ display: "flex", alignItems: "center" }}>
              {getTranslation(translations, "settings.comments.label")}
              {commentsCount > 0 && (
                <Box
                  component="span"
                  sx={{
                    ml: 0.5,
                    minWidth: 16,
                    height: 16,
                    px: 0.5,
                    borderRadius: 1,
                    bgcolor: "error.main",
                    color: "common.white",
                    fontSize: 9,
                    fontWeight: 800,
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {commentsCount}
                </Box>
              )}
            </Box>
          }
        />
        <Tab
          value="history"
          icon={<HistoryIcon sx={{ fontSize: 14 }} />}
          iconPosition="start"
          label={
            <Box sx={{ display: "flex", alignItems: "center" }}>
              {getTranslation(translations, "settings.histories.label")}
              {historyCount > 0 && (
                <Box
                  component="span"
                  sx={{
                    ml: 0.5,
                    minWidth: 16,
                    height: 16,
                    px: 0.5,
                    borderRadius: 1,
                    bgcolor: "primary.main",
                    color: "common.white",
                    fontSize: 9,
                    fontWeight: 800,
                    display: "inline-flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {historyCount}
                </Box>
              )}
            </Box>
          }
        />
      </Tabs>
    </Box>
  );
};

export default MobileDetailTabBar;